import PropTypes from 'prop-types';
import React from 'react';

class NavigationSearchBox extends React.Component {
  render() {
    const { text, icon, handleTextChange, handleSubmit, handleIconClick } = this.props;

    return (
      <form
        id="search"
        role="search"
        className="search-form"
        autoComplete="off"
        onSubmit={event => handleSubmit(event, this.input)}
      >
        <div className="navigation-bar-search form-group search-control">
          <label htmlFor="nav-search-input" onClick={handleIconClick}>
            <i className={`icon-budicon-${icon}`} />
          </label>
          <input
            ref={(input) => { this.input = input; }}
            value={text}
            id="nav-search-input"
            className="search-input form-control"
            placeholder="Search for docs"
            onChange={handleTextChange}
          />
        </div>
      </form>
    );
  }
}

NavigationSearchBox.propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.number.isRequired,
  handleTextChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleIconClick: PropTypes.func.isRequired
};

export default NavigationSearchBox;
